import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormDashboardLabel as Label, Table, User } from '../../../components'
import { fetchIndividu } from '../../../features/individu/slice'
import service from '../../../features/join-requests/service'
import { fetchInvitations } from '../../../features/invitations/slice'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { errorHandler } from '../../../utils'
import { useInternationalization } from '../../../features/i18n'

const ACCEPT = 1
const REJECT = 2

const label = {
  from: {
    en: 'From',
    id: 'Dari'
  },
  accept: {
    en: 'Accept',
    id: 'Terima'
  },
  reject: {
    en: 'Reject',
    id: 'Tolak'
  }
}

const Invitations = () => {
  const dispatch = useDispatch()
  const [requesting, setRequesting] = React.useState(false)
  const status = useSelector(state => state.invitations.status)
  const statusIndividu = useSelector(state => state.individu.status)
  const id = useSelector(state => state.account.profile.userId)
  const invitations = useSelector(state => state.individu.invitations)
  const { language, translate } = useInternationalization()

  React.useEffect(() => {
    if(status === 'idle'){
      dispatch(fetchInvitations())
    }
  }, [dispatch, status])

  React.useEffect(() => {
    if(statusIndividu === 'idle'){
      dispatch(fetchIndividu(id))
    }
  }, [dispatch, statusIndividu, id])

  const respond = (id, status) => {
    setRequesting(true)

    service.respond(id, status)
    .then(res => {
      console.log({res})
      alert('Invitation successfully responded!')
      window.location.reload()
    })
    .catch(err => {
      console.log({err})
      const msg = errorHandler(err)
      toast.error(msg)
    })
    .then(() => setRequesting(false))
  }

  const tableData = useMemo(() => invitations, [invitations])
  const tableColumns = useMemo(
    () => [
      {
        Header: label.from[language.name],
        accessor: 'sender.name',
        Cell: (props) => {
          const id = props.data[props.row.index].sender.id
          return (
            <Link to={`/organization/${id}`}>
              <User small name={props.value} />
            </Link>
          )
        }
      },
      {
        Header: 'Status',
        accessor: 'status.name',
      },
      {
        Header: '',
        accessor: 'id',
        Cell: ({value}) => {
          return (
            <div className="flex items-center justify-end">
              <div
                className="cursor-pointer text-sm underline text-primary mr-4"
                onClick={() => requesting ? {} : respond(value, ACCEPT)}
              >
                {label.accept[language.name]}
              </div>
              <div
                className="cursor-pointer text-sm underline text-error-text"
                onClick={() => requesting ? {} : respond(value, REJECT)}
              >
                {label.reject[language.name]}
              </div>
            </div>
          )
        }
      }
    ],
    [requesting, language.name]
  )

  return (invitations && invitations.length > 0) ? (
    <div className="lg:border lg:rounded lg:p-4 mt-5 lg:mt-8">
      <Label>{translate('ORGANIZATION', 'invitations')}</Label>

      <Table
        data={tableData}
        columns={tableColumns}
      />
    </div>
  ) : (<></>)
}

export { Invitations }
